import { STAGE_AUTO_NAVIGATION,
        NAVIGATE_PAGE } from './actionTypes'

export function navigatePage(url, navType, stateLocation) {
    return {
        type : NAVIGATE_PAGE,
        payload : {
            url,
            navType,
            stateLocation
        }
    };
}

export function stageAutoNavigation(navUrl, stateLocation) {
    return {
        type : STAGE_AUTO_NAVIGATION,
        payload : {
            navUrl,
            stateLocation
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/auto-nav-url/src/actions/actions.js